import api from './api';

export function fetchReport({
  supplier_id,
  report_type,
  start_date,
  end_date,
  client_timezone,
  date_type,
  currency,
  columns,
  retailer_ids,
  warehouse_ids,
  group_by,
  country_codes,
  filters,
}) {
  return api.post('/analytics/export', {
    supplier_id,
    report_type,
    start_date,
    end_date,
    client_timezone,
    date_type,
    currency: currency.toUpperCase(),
    retailer_ids: retailer_ids.map(Number),
    warehouse_ids: warehouse_ids.map(Number),
    columns,
    group_by,
    country_codes,
    filters,
  });
}
